import { api } from "@/modules/api";
import { getBackendApiErrorMessage } from "@/modules/api/errorHandling";

export async function requestNoteReviewNow(noteId: string): Promise<void> {
  const response = await api.post("/v2/notes/{note_id}/review-now", {
    params: { path: { note_id: noteId } },
  });
  if (response.error || !response.data) {
    throw new Error(
      getBackendApiErrorMessage(response.error) ?? "Could not request a note review."
    );
  }
}
